import Consumption from '../../../../base/forms/airdome/consumption';

const consumption: Consumption = {
  start: 'Start',
  end: 'End'
};

export default consumption;
